<template>
  <span>
    <v-file-input
      v-if="editing"
      :disabled="disabled"
      :value="imgup"
      @change="changed"
      :label="label"
      accept="image/svg+xml, image/png"
      ref="atinput"
    ></v-file-input>
    <span v-else>
      <v-dialog v-model="dialog" persistent>
        <template v-slot:activator="{ on, attrs }">
          <img :src="imgurl" class="svgcell ma-1" height="100" width="100" v-on="on" v-bind="attrs" />
        </template>

        <v-card>
          <v-card-text>
            <v-layout column wrap>
              <img :src="imgurl" class="ma-2" />
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">{{ $t('common.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </span>
  </span>
</template>

<script>
import ATInputMixin from "./ATInputMixin.js";

export default {
  mixins: [ATInputMixin],
  data() {
    return {
      imgup: undefined,
      dialog: false
    };
  },
  computed: {
    imgurl() {
      this.$log.debug("SVG: trxtext= " + this.trxtext);
      return this.trxtext;
    }
  },
  methods: {
    imgselected() {
      this.changed(this.imgup);
    }
  }
};
</script>

<style scoped>
.svgcell {
  max-height: 100px;
}
</style>